<template>
    <div class="resource-reference">
        <resource v-if="resource" :content="resource" />
    </div>
</template>

<script>
    export default {
        name: 'ResourceReference',
        props: {
            configuration: Object
        },
        computed: {
            resource(){
                return this.configuration.contents.slice().pop();
            }
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .resource-reference
    {
        margin: 50px 0;
        max-width: 800px;
        padding: 30px;
        border: 1px solid @e4;
        border-radius: 5px;

        .resource-summary
        {
            padding: 0;
            border-bottom: 0;

            .thumbnails
            {
                margin-top: 10px;
            }
        }
    }
</style>